<template>
  <v-dialog v-model="showLocalDialog" width="80vw" height="80vh">
    <v-card width="80vw" height="80vh">
      <v-card-text class="pa-4 iframeContainer">
        <iframe :src="buildUrl" width="100%" height="100%"></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      url: {
        type: String,
        required: false
      },
      showDialog: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return { showLocalDialog: this.showDialog };
    },
    watch: {
      showDialog(val) {
        this.showLocalDialog = val;
      },
      showLocalDialog(val) {
        if (!val) this.$emit('close', val);
      }
    },
    computed: {
      buildUrl() {
        return this.url + '#page=1&navpanes=0&zoom=page-width&view=FitW';
      }
    }
  };
</script>

<style scoped>
  .iframeContainer {
    height: 100%;
  }
</style>
